const millisPerHour = 1000 * 60 * 60;

export default class TimeFormatter {
    constructor() {        
    }

    /**
     * @param {number} milliseconds
     * @returns {string}
     */
    static formatElapsedTime(milliseconds) {
        if (milliseconds < 0) {
            return 'Error: negative time';
        }

        const hours = (milliseconds / millisPerHour) | 0,
            minutes = ((milliseconds / 60000) % 60) | 0,
            seconds = ((milliseconds / 1000) % 60) | 0;

        return (hours < 10 ? '0' : '') + hours
            + ':'
            + (minutes < 10 ? '0' : '') + minutes
            + ':'
            + (seconds < 10 ? '0' : '') + seconds;
    }

    /**
     * @param {number} milliseconds
     * @returns {string}
     */
    static formatElapsedTimeNoHours(milliseconds) {
        if (milliseconds < 0) {
            return 'Error: negative time';
        }

        const hours = (milliseconds / millisPerHour) | 0,
            minutes = ((milliseconds / 60000) % 60) | 0,
            seconds = ((milliseconds / 1000) % 60) | 0;

        // Only show the hours if it is more than 0.
        if (hours > 0) {
            return (hours < 10 ? '0' : '') + hours
                + ':'
                + (minutes < 10 ? '0' : '') + minutes
                + ':'
                + (seconds < 10 ? '0' : '') + seconds;
        }
        else {
            return (minutes < 10 ? '0' : '') + minutes
                + ':'
                + (seconds < 10 ? '0' : '') + seconds;
        }
    }

}